import { Box } from '@mui/material';
import React, { useState } from 'react';
import { KitButton, KitCard, KitList } from '../common/MobileKit';
import { MobileListRow } from '../common/MobileCrud';
import { KitKV } from '../common/MobileKitExtras';
import { KitEmptyNote } from '../common/MobileDashboardKit';

/**
 * Peças genéricas dos relatórios mobile (Clientes, Veículos): lista paginada com
 * "Carregar mais", trio de números (`stat-tile`) e cartão de pares rótulo/valor.
 * Só apresentação: os dados e cálculos vêm da tela do relatório.
 */

// `.list` com `MobileListRow`, "Exibindo N de M" e "Carregar mais".
// rows: [{ key, title, sub, end, avatar, icon, onClick }]
export function PagedRows({ rows, empty, noun = 'itens', pageSize = 20, paged = true }) {
    const [visible, setVisible] = useState(pageSize);
    if (rows.length === 0) return <KitCard><KitEmptyNote>{empty}</KitEmptyNote></KitCard>;
    const shown = paged ? rows.slice(0, visible) : rows;
    return (
        <>
            <KitList>
                {shown.map((row, index) => (
                    <MobileListRow
                        key={`${row.key ?? row.title}-${index}`}
                        avatar={row.avatar}
                        icon={row.icon}
                        title={row.title}
                        sub={row.sub}
                        end={row.end}
                        chevron={Boolean(row.onClick)}
                        onClick={row.onClick}
                    />
                ))}
            </KitList>
            {paged && (
                <Box sx={{ textAlign: 'center', fontSize: 12, color: 'text.disabled', m: '10px 0 6px', lineHeight: 1.4 }}>
                    Exibindo {shown.length} de {rows.length} {noun}
                </Box>
            )}
            {paged && visible < rows.length && (
                <KitButton block sx={{ width: '100%' }} onClick={() => setVisible((v) => v + pageSize)}>Carregar mais</KitButton>
            )}
        </>
    );
}

// Valor à direita (negrito 14) das linhas.
export function RowValue({ children, color }) {
    return <Box sx={{ fontWeight: 800, fontSize: 14, lineHeight: 1.4, color: color || 'text.primary' }}>{children}</Box>;
}

// Números em destaque lado a lado (`stat-tile`): items [{ label, value }].
export function StatTiles({ items }) {
    return (
        <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))`, gap: '10px' }}>
            {items.map((item) => (
                <KitCard key={item.label} sx={{ p: '12px 8px', textAlign: 'center', minWidth: 0 }}>
                    <Box sx={{ fontSize: 21, fontWeight: 800, letterSpacing: '-.02em', lineHeight: 1.4 }}>{item.value}</Box>
                    <Box sx={{ fontSize: 11, fontWeight: 600, color: 'text.disabled', lineHeight: 1.3 }}>{item.label}</Box>
                </KitCard>
            ))}
        </Box>
    );
}

// Cartão com pares rótulo/valor (`.kv`): rows [{ label, value }].
export function KvCard({ rows }) {
    return (
        <KitCard>
            {rows.map((row) => <KitKV key={row.label} label={row.label} value={row.value} />)}
        </KitCard>
    );
}
